<template>
  <KChip :href="href" x-small target="_blank" icon="mdi-open-in-new" class="pr-0" />
</template>

<script>
import KChip from "@/components/KChip";
export default {
  components: {
    KChip
  },

  props: {
    person_id: [Number, String]
  },

  computed: {
    href() {
      return `/people/view/${this.person_id}`
    }
  },
};
</script>

<style></style>
